import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import CraftHeritage from "./sections/CraftHeritage";
import MilestonesOfIntegrity from "./sections/MilestonesOfIntegrity";
import Footer from "@/reusable_sections/Footer";
export default function OurStoryPage() {
  return <div>
      <Header />
      <CraftHeritage />
      <MilestonesOfIntegrity />
      <Footer />
    </div>;
}